var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenuBody.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@wds/grid';
import SMHeaderContext from '../../../SMHeaderContext';
export var SubMenuBody = function SubMenuBody(_ref) {
  var children = _ref.children;
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  return /*#__PURE__*/React.createElement(Grid, {
    noBleeds: lang === 'en',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 10
    }
  }, children);
};
SubMenuBody.propTypes = {
  children: PropTypes.node.isRequired
};
export default SubMenuBody;
//# sourceMappingURL=SubMenuBody.js.map